export const CLEAR_FOLDER_SELECT_BOX =
  'app/FolderSelectBox/CLEAR_FOLDER_SELECT_BOX'
export const CLEAR_FOLDER_PROJECTS = 'app/FolderSelectBox/CLEAR_FOLDER_PROJECTS'
export const CLEAR_PROJECTS = 'app/FolderSelectBox/CLEAR_PROJECTS'
export const SET_CURRENT_FOLDER_ID = 'app/FolderSelectBox/SET_CURRENT_FOLDER_ID'
export const SET_SEARCH = 'app/FolderSelectBox/SET_SEARCH'
export const SET_GET_PROJECT_TREE_CANCEL_TOKEN =
  'app/FolderSelectBox/SET_GET_PROJECT_TREE_CANCEL_TOKEN'
export const GET_ROOT_PROJECTS = 'app/FolderSelectBox/GET_ROOT_PROJECTS'
export const GET_ROOT_PROJECTS_DONE =
  'app/FolderSelectBox/GET_ROOT_PROJECTS_DONE'
export const GET_ROOT_PROJECTS_ERROR =
  'app/FolderSelectBox/GET_ROOT_PROJECTS_ERROR'
export const GET_FOLDER_PROJECTS = 'app/FolderSelectBox/GET_FOLDER_PROJECTS'
export const GET_FOLDER_PROJECTS_DONE =
  'app/FolderSelectBox/GET_FOLDER_PROJECTS_DONE'
export const GET_FOLDER_PROJECTS_ERROR =
  'app/FolderSelectBox/GET_FOLDER_PROJECTS_ERROR'

export const CLEAR_PLAN_FOLDER_SELECT_BOX =
  'app/FolderSelectBox/CLEAR_PLAN_FOLDER_SELECT_BOX'
export const CLEAR_PLANS = 'app/FolderSelectBox/CLEAR_PLANS'
export const CLEAR_FOLDER_PLANS = 'app/FolderSelectBox/CLEAR_FOLDER_PLANS'
export const GET_ROOT_PLANS = 'app/FolderSelectBox/GET_ROOT_PLANS'
export const GET_ROOT_PLANS_DONE = 'app/FolderSelectBox/GET_ROOT_PLANS_DONE'
export const GET_ROOT_PLANS_ERROR = 'app/FolderSelectBox/GET_ROOT_PLANS_ERROR'
export const GET_FOLDER_PLANS = 'app/FolderSelectBox/GET_FOLDER_PLANS'
export const GET_FOLDER_PLANS_DONE = 'app/FolderSelectBox/GET_FOLDER_PLANS_DONE'
export const GET_FOLDER_PLANS_ERROR =
  'app/FolderSelectBox/GET_FOLDER_PLANS_ERROR'
export const SET_CURRENT_PLAN_FOLDER_ID =
  'app/FolderSelectBox/SET_CURRENT_PLAN_FOLDER_ID'
export const SET_GET_PLAN_TREE_CANCEL_TOKEN =
  'app/FolderSelectBox/SET_GET_PLAN_TREE_CANCEL_TOKEN'

export const CLEAR_PLAN_SELECT_BOX = 'app/FolderSelectBox/CLEAR_PLAN_SELECT_BOX'
export const CLEAR_PLANS_WITH_FOLDERS =
  'app/FolderSelectBox/CLEAR_PLANS_WITH_FOLDERS'
export const GET_ROOT_PLANS_WITH_FOLDERS =
  'app/FolderSelectBox/GET_ROOT_PLANS_WITH_FOLDERS'
export const GET_ROOT_PLANS_WITH_FOLDERS_DONE =
  'app/FolderSelectBox/GET_ROOT_PLANS_WITH_FOLDERS_DONE'
export const GET_ROOT_PLANS_WITH_FOLDERS_ERROR =
  'app/FolderSelectBox/GET_ROOT_PLANS_WITH_FOLDERS_ERROR'
export const GET_FOLDER_PLANS_WITH_FOLDERS =
  'app/FolderSelectBox/GET_FOLDER_PLANS_WITH_FOLDERS'
export const GET_FOLDER_PLANS_WITH_FOLDERS_DONE =
  'app/FolderSelectBox/GET_FOLDER_PLANS_WITH_FOLDERS_DONE'
export const GET_FOLDER_PLANS_WITH_FOLDERS_ERROR =
  'app/FolderSelectBox/GET_FOLDER_PLANS_WITH_FOLDERS_ERROR'
export const SET_CURRENT_PLAN_WITH_FOLDERS_FOLDER_ID =
  'app/FolderSelectBox/SET_CURRENT_PLAN_WITH_FOLDERS_FOLDER_ID'
export const SET_GET_PLAN_WITH_FOLDERS_TREE_CANCEL_TOKEN =
  'app/FolderSelectBox/SET_GET_PLAN_WITH_FOLDERS_TREE_CANCEL_TOKEN'
